import React from 'react';
import './App.css';
import LandingPage from './pages/LandingPage';
import './pages/LandingPage.css';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;